export enum SaveViewFormFields {
  Name = 'name',
  LinkName = 'linkName',
  Columns = 'columns',
}
